module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content",
    staticStyle: {
      "background-color": "white"
    }
  }, [_c('div', [_c('nav', {
    staticClass: "bar bar-nav"
  }, [_c('a', {
    staticClass: "button button-link button-nav pull-left",
    on: {
      "click": function($event) {
        return _vm.gotolast()
      }
    }
  }, [_c('span', {
    staticClass: "icon icon-left"
  }), _vm._v("返回\n      ")])])]), _vm._v(" "), _c('div', [(_vm.channels) ? _c('div', {
    staticStyle: {
      "margin-bottom": "10px",
      "margin-top": "2.5rem"
    }
  }, [_c('div', {
    staticClass: "card demo-card-header-pic"
  }, [_c('div', {
    staticClass: "card-header color-white no-border no-padding",
    attrs: {
      "valign": "bottom"
    }
  }, [_c('img', {
    staticClass: "card-cover",
    attrs: {
      "src": _vm.baseurl + _vm.channels.descUrl
    }
  })])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "3rem"
    }
  }, _vm._l((_vm.channels.promotionList), function(pro) {
    return _c('div', {
      staticClass: "card"
    }, [_c('div', {
      staticStyle: {
        "margin-top": "1rem",
        "margin-bottom": "4rem",
        "background-color": "#F7E7D8"
      },
      on: {
        "click": function($event) {
          return _vm.gotoPro(pro)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "text-align": "left",
        "font-size": "x-large",
        "margin-bottom": "0.5rem",
        "margin-top": "0.5rem"
      }
    }, [_vm._v("\n          " + _vm._s(pro.name) + "\n        ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "left"
      }
    }, [_vm._v("\n          " + _vm._s(pro.description) + "\n        ")]), _vm._v(" "), _c('div', {
      staticStyle: {
        "text-align": "right",
        "margin-bottom": "0.5rem"
      }
    }, [_vm._v("点击进入活动专场")])])])
  }), 0)]) : _vm._e(), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "card-content-inner"
  }, [_vm._v("信号通路研究，是做基础科研接触最多的一个方面，不管是设计课题写基金还是发表文章，都需要对信号通路有一定的了解。常在文章里面见到各种各样的信号通路，比如经典的P53信号通路、NF-κB信号、Wnt信号通路等等。\n         "), _c('br'), _vm._v("\n          现在吉凯基因将持续不断的推出各类经典通路的促销活动，免除您有做通路研究的决心而无经费支持的尴尬，为您的科研提供最有利的保障。赶紧点击详情了解一下！\n        ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0dbcd38a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Channels/Channel.vue
// module id = 1534
// module chunks = 8